(function(_){
    'use strict';
    _['OUTLETS.KEY']='Outlets';
    _['OUTLETS.NO-PROMOTIONS']='There is no available promotion';
}(translations['en']));


// WEBPACK FOOTER //
// ./src/app/modules/outlets/lang/outlets-lang_en.js